
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import moment from "moment";
import {
  CourseTransactionStatusEnum,
  PaymentTypeEnum,
} from "@/constants/enum.constant";
import VueQrcode from "@chenfengyuan/vue-qrcode";

@Component({
  components: {
    AppLayout,
    VueQrcode,
  },
  filters,
})
export default class Payment extends Vue {
  @Action("getInvoiceDetail", { namespace: "payment" })
  private getInvoiceDetail: any;

  private transaction: any = null;
  private countdown = "00:00:00";
  private interval: any = null;
  private refreshInterval: any = null;

  private get isPending() {
    return (
      this.transaction?.latest_history.status ===
      CourseTransactionStatusEnum.PENDING
    );
  }
  private get isRejected() {
    return (
      this.transaction?.latest_history.status ===
      CourseTransactionStatusEnum.REJECTED
    );
  }
  private get isApproved() {
    return (
      this.transaction?.latest_history.status ===
      CourseTransactionStatusEnum.APPROVED
    );
  }
  private get isExpired() {
    return (
      this.transaction?.latest_history.status ===
      CourseTransactionStatusEnum.EXPIRED
    );
  }
  private get isOvo() {
    return this.transaction?.payment_type === PaymentTypeEnum.OVO;
  }
  private get isDana() {
    return this.transaction?.payment_type === PaymentTypeEnum.DANA;
  }
  private get isQris() {
    return this.transaction?.payment_type === PaymentTypeEnum.QRIS;
  }

  private created() {
    this.getData();
  }

  private getData() {
    this.getInvoiceDetail({
      params: {
        invoice: this.$route.params.invoice,
      },
      success: (response: AxiosResponse) => {
        this.transaction = response.data.data;
        this.startCountdown();
        this.startAutoRefresh();
      },
    });
  }

  private startAutoRefresh() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this.isPending) {
      this.refreshInterval = setInterval(() => {
        this.getInvoiceDetail({
          params: {
            invoice: this.$route.params.invoice,
          },
          success: (response: AxiosResponse) => {
            this.transaction = response.data.data;
            if (!this.isPending) {
              clearInterval(this.refreshInterval);
              this.refreshInterval = null;
            }
          },
        });
      }, 10000);
    }
  }

  private destroyed() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private startCountdown() {
    this.interval = setInterval(() => {
      let now = new Date().getTime();
      let distance =
        moment
          .utc(this.transaction?.created_at)
          .local()
          .add(30, "minutes")
          .unix() *
          1000 -
        now;
      if (distance > 0) {
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        let counter = {
          days: days.toString().length < 2 ? ("0" + days).slice(-2) : days,
          hours: ("0" + hours).slice(-2),
          minutes: ("0" + minutes).slice(-2),
          seconds: ("0" + seconds).slice(-2),
        };

        this.countdown = `${counter.hours}:${counter.minutes}:${counter.seconds}`;
      } else {
        clearInterval(this.interval);
      }
    });
  }

  private retry() {
    if (this.transaction.type === "Single") {
      this.$router.push({
        name: "course-detail",
        params: {
          slug: this.transaction?.course?.slug,
        },
      });
    } else {
      this.$router.push({
        name: "bundle-course-detail",
        params: {
          slug: this.transaction?.bundle?.slug,
        },
      });
    }
  }

  private goToMyCourses() {
    this.$router.push({
      name: "my-courses",
    });
  }

  private downloadQr() {
    const href = document.getElementById("qr-img")?.getAttribute("src") as any;
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "QR.png");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }
}
